export const CONFERENCE_INFO = {
    alwaysVisible: [ 'recording', 'local-recording', 'raised-hands-count' ],
    autoHide: [
        'subject',
        'conference-timer',
        'participants-count',
        'e2ee',
        'transcribing',
        'video-quality',
        'insecure-room'
    ]
};
